var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.detail},[_c('div',{class:_vm.$style.box},[_c('p',{class:_vm.$style.content,staticStyle:{"white-space":"pre-wrap"}},[_vm._v(" "+_vm._s(_vm.detailContent[0] && _vm.detailContent[0].doc)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }